import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CoachDto } from "../../../models/coach/dto/coach.dto";
import { GET_COACHS_QUERY_KEY } from "./useListCoachs";

export const useDeleteCoach = (coachId: string, organizationId: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['delete', coachId],
        mutationFn: () => apiClient.fetchApi({ method: 'POST', endpoint: `coachs/${coachId}/delete` }),
        onSuccess: () => {
            queryClient.setQueryData(GET_COACHS_QUERY_KEY(organizationId), (oldData: CoachDto[]) => {
                return oldData.filter((coach) => coach.id !== coachId);
            });
        }
    });
};
